import purchaseOrderService from "../../../../services/procurementService/purchaseOrderService";
import { useQuery } from "@tanstack/react-query";
import { DataSelectType } from "../../../../models/DataSelectType";
import { CACHE_KEY_PURCHASEORDERS } from "../../../../utils/constants";
import { PurchaseOrderInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrder";

const usePurchaseOrders = (
  page: number,
  pageSize: number,
  filters?: DataSelectType[]
) =>
  useQuery<PurchaseOrderInterface[], Error>({
    queryKey: [CACHE_KEY_PURCHASEORDERS, page, pageSize],
    queryFn: () => purchaseOrderService.GetAll(page, pageSize, filters),
    initialData: [],
  });

export default usePurchaseOrders;
